import { useLoginDialogStore } from "@/stores/login-dialog-store";
import type { LoginDialogOptions } from "@/stores/login-dialog-store";

export type { LoginDialogOptions };

export function useLoginDialog() {
	return useLoginDialogStore();
}
